import React from 'react';
import {Outlet, useNavigate} from "react-router-dom";
import getMenuItems from "./adminPanelMenuItems";

const AdminPanelLayout = () => {
    const navigate = useNavigate();
    const menuItems = getMenuItems(navigate);

    return (
        <>
            <div style={{
                width: "100%",
                height: "50px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                position: "fixed",
                top: "0px",
                backgroundColor: "#f0f0f0",
                borderBottom: "1px solid #ccc"
            }}>
                <div
                    style={{margin: "0 15px", cursor: "pointer", fontWeight: "bold", fontSize:"20px", color: "#333"}}
                    onClick={() => navigate("/admin")}
                >
                    Admin Panel
                </div>
                {menuItems.map((item, index) => (
                    <div
                        key={index}
                        onClick={item.onClick}
                        style={{margin: "0 15px", cursor: "pointer", fontWeight: "bold", color: "#333"}}
                    >
                        {item.label}
                    </div>
                ))}
            </div>
            <div style={{paddingTop: "50px"}}>
                <Outlet/>
            </div>
        </>
    );
};

export default AdminPanelLayout;
